export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar reporte"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva factura"])},
          "total_number_org_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["facturas"])},
          "total_number_org_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["facturas pagadas"])}
        }
      }
    }
  })
}